import { Stack, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';
import { Panel } from 'src/UIKit';

export type StatLegendItem = {
  label: string;
  value: number;
};

// Compact, neutral stat tiles matching the app's squared-corner cards. No
// per-metric color — these are top-level totals, not chart legends.
export default function StatLegend({
  items,
  loading,
  sx,
}: {
  items: StatLegendItem[];
  loading?: boolean;
  sx?: SxProps<Theme>;
}) {
  return (
    <Stack direction="row" flexWrap="nowrap" columnGap={2} sx={{ width: '100%', ...sx }}>
      {items.map(item => (
        <Panel
          key={item.label}
          sx={{
            flex: '1 1 0',
            minWidth: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
            px: 1.5,
            py: 1,
          }}
        >
          <Typography
            component="span"
            noWrap
            variant="caption"
            fontWeight="fontWeightMedium"
            color="text.secondary"
          >
            {item.label}
          </Typography>
          <Typography component="span" fontSize="1.1rem" fontWeight="fontWeightBold" lineHeight={1.1}>
            {loading ? '—' : item.value.toLocaleString('en-US')}
          </Typography>
        </Panel>
      ))}
    </Stack>
  );
}
